<template>
  <div class="fields-page">

    <fields-hero-section
      :fields="fieldsPageSections.sections.fields_hero_section.fields"
    />

    <fields-divider-section
      :fields="fieldsPageSections.sections.fields_divider_section.fields"
    />

    <fields-cover-section
      :fields="fieldsPageSections.sections.fields_cover_section.fields"
    />

    <fields-text-section
      :fields="fieldsPageSections.sections.fields_text_section.fields"
    />


    <fields-feature-section
      :fields="fieldsPageSections.sections.fields_feature_section.fields"
    />

  </div>
</template>

<script>
import DividerSection from "/seu-frontend/sections/general/DividerSection";
import FieldsHeroSection from "/seu-frontend/sections/fields-page/FieldsHeroSection";
import FieldsCoverSection from "/seu-frontend/sections/fields-page/FieldsCoverSection";
import FieldsTextSection from "/seu-frontend/sections/fields-page/FieldsTextSection";
import FieldsFeatureSection from "/seu-frontend/sections/fields-page/FieldsFeatureSection";
import FieldsDividerSection from "/seu-frontend/sections/fields-page/FieldsDividerSection";

export default {
  name: "FieldsPage",
  components: {
    FieldsDividerSection,
    FieldsFeatureSection,
    FieldsTextSection,
    FieldsCoverSection,
    FieldsHeroSection,
    DividerSection,
  },

  computed: {
    fieldsPageSections() {
      return require(`../services/pages/${this.$store.state.currentLanguage.toLowerCase()}/fieldsPage`).default;
    }
  },
  metaInfo(){
    return  {
      title: this.fieldsPageSections.title,
    }
  }
}
</script>

<style lang="scss">
@import "FieldsPage.scss";
</style>
